export const getBrowserLocale = () => {
  if (typeof navigator === "undefined") return;

  const browserLanguage = navigator?.language?.split("-");
  const browserLocale = browserLanguage && browserLanguage[0];

  return browserLocale;
};
